import React from 'react';
const version = (window as any).__RUNTIME_CONFIG__?.VITE_APP_VERSION || import.meta.env.VITE_APP_VERSION;
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div>
        <span>© {currentYear} VaultiScan Inc. All rights reserved.</span>
        <span>Version {version}</span>
      </div>
    </footer>
  );
};

export default Footer;
